<template>
  <v-row class="table" fluid="true">
    <v-col class="table__col table__header" >
      <v-row class="table__row">
        <v-col class="table__col table__col--title" cols="5">기사</v-col>
        <v-col class="table__col table__col--title" cols="7">
          <div class="vehicle-item__title">차량</div>
          <div>예상운행 / 실제운행 (km)</div>
        </v-col>
      </v-row>
      <template v-for="(header, index) in headers">
        <v-row :key="index" class="table__row">
          <v-col class="table__col table__col--title" cols="5">
            {{ header[0].driverName }}
          </v-col>
          <v-col class="table__col table__col--subtitle" cols="7">
            <template v-for="(headerSubItem, index) in header">
              <v-row class="table__row table__row--subtitle" :key="index">
                <slot name="vehicleInfo" :item="headerSubItem"></slot>
              </v-row>
            </template>
          </v-col>
        </v-row>
      </template>
    </v-col>

    <v-col class="table__col table__content" ref="timeTable">
      <v-row
        class="table__row table__content--header"
        :style="{ width: contentWidth + 'px' }"
      >
        <template v-for="(time, index) in times">
          <v-col :key="index" :style="styleTime(time)" class="table__col table__col--title">
            {{ time.format("HH:mm") }}
          </v-col>
        </template>
      </v-row>
      <template v-for="(content, index) in contents">
        <v-row
          :key="index"
          class="table__row table--data-cell"
          :style="{ width: contentWidth + 'px' }"
        >
          <v-divider
            vertical
            v-if="nowDate"
            class="table--divider"
            :style="dividerPosition"
          ></v-divider>
          <v-col class="table__col">
            <template v-for="(schedule, index) in content">
              <c-calendar-schedule
                :key="index"
                :schedule="schedule"
                :selectedDate="selectedDate"
                :start="startTime"
                :end="endTime"
                :contentWidth="contentWidth"
                :unitWidth="unitWidth"
                :disableTooltip="checkDisableTooltip(schedule)"
                :disableMenu="checkDisableMenu(schedule)"
              >
                <template #tooltipInfo="schedule">
                  <c-scheduler-tooltip :schedule="schedule" />
                </template>
                <template #menuInfo="schedule">
                  <slot name="menuInfo" :schedule="schedule"></slot>
                </template>
              </c-calendar-schedule>
            </template>
          </v-col>
        </v-row>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import CCalendarSchedule from "../components/CCalendarSchedule.vue";
import CSchedulerTooltip from "../components/CSchedulerTooltip.vue";

export default {
  components: { CCalendarSchedule, CSchedulerTooltip },
  props: {
    selectedDate: {
      type: String,
    },
    headers: {
      type: Array,
    },
    contents: {
      type: Array,
    },
    startTime: {
      type: Number,
    },
    endTime: {
      type: Number,
    },
    onTooltip: {
      type: Function,
    },
    onMenu: {
      type: Function,
    },
    isActive: {
      type: Boolean
    }
  },
  data() {
    return {
      columnSize: 60, // time당 한 column 사이즈
      sizeUnit: "px",
    };
  },
  computed: {
    times() {
      return Array.from({ length: 24 }, (v, i) =>
        this.$moment(i, "H")
      );
    },
    baseTimes() {
      return Array.from({ length: this.endTime - this.startTime }, (v, i) =>
        this.$moment(this.startTime + i, "H")
      );
    },
    contentWidth() {
      return this.times.length * this.columnSize;
    },
    unitWidth() {
      return this.columnSize / 60; // TODO: 분당 em 사이즈 변화하도록 수정 (min: 1, max: 유동적)
    },
    dividerPosition() {
      const startPosition = this.$moment
        .duration(this.$moment().diff(this.$moment(0, "H")))
        .asMinutes();
      return {
        left: startPosition * this.unitWidth + "px",
        borderColor: "red",
      };
    },
    nowDate() {
      return this.selectedDate === this.$func.curDateString();
    }
  },
  methods: {
    onResize() {
      const resizingColumnSize =
        this.$refs.timeTable.offsetWidth / this.baseTimes.length;
      this.columnSize = resizingColumnSize <= 60 ? 60 : resizingColumnSize;
    },
    onUpdate() {
      this.$refs.timeTable.scrollLeft = this.columnSize * this.startTime;
    },
    checkDisableTooltip(schedule) {
      return !['reservation', 'delivery', 'breakTime'].includes(schedule.category);
    },
    checkDisableMenu(schedule) {
      return !['reservation', 'delivery', 'breakTime'].includes(schedule.category);
    },
    styleTime(time) {
      if (!this.nowDate) {
        return null;
      }

      if (time.hours() === this.$moment().hours()) {
        return {
          color: 'red'
        };
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      this.onResize();
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  updated() {
    if (this.isActive) {
      this.onResize();
      this.onUpdate();
    }
  },
};
</script>
<style scoped>
.table {
  border: 1px solid lightgrey;
  padding: 0;
  margin: 0;
  background-color: #F7F7F7;
}

.table__header {
  padding: 0;
  min-width: 250px;
}

.table__header > .table__row:first-child {
  height: 43px;
}

.table__content {
  padding: 0;
  overflow-x: auto;
  min-width: calc(100% - 250px);
}

.table__content--header {
  width: max-content;
}

.table__row {
  border-bottom: 1px solid lightgrey;
  flex-flow: row nowrap;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.table__row:last-child {
  border-bottom: none;
}

.table__col {
  border-right: 1px solid lightgrey;
  padding: 0;
}

.table__content .table__col {
  min-width: 5em;
}

.table__col--title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  padding: 12px;
}

.table__col--subtitle {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.table__row--subtitle {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 42px;
  box-sizing: content-box;
}

.table__row--subtitle:last-child {
  box-sizing: border-box;
}

.table__col:last-child {
  border-right: none;
}

.table--data-cell {
  position: relative;
  padding: 0;
}

.table--data-cell .table__col {
  height: 42px;
  box-sizing: border-box;
  padding: 12px;
}

.table--divider {
  position: absolute;
  height: 100%;
  border-width: 1px;
  z-index: 4;
}

.vehicle-item__title {
  font-size: 14px;
}
</style>
